<template>
    <div>
        <div class="searchcontent headersearch"  >
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                
                <el-form-item>
                    <el-input size="small" v-model.trim="searchForm.keywords" placeholder="请输入申请人姓名" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size="small" v-model.trim="certificateNo" placeholder="请输入申请人证件号" onkeyup="this.value=this.value.replace(/[^\X0-9]/g, '')"></el-input>
                </el-form-item>
                 <el-form-item>
                    <el-select size="small"   style="width:250px" v-model="searchForm.registered" placeholder="请选择户口性质" >
                        <el-option
                        v-for="item in searchForm.registeredlist"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                         
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="show">
                    <el-select size="small" v-model="searchForm.countryID"  style="width:200px"  placeholder="请选择户籍乡级行政区划" @change="searchFormchange(5,searchForm.countryID)" >
                            <el-option
                            v-for="item in countryList"
                            :key="item.baseRegionID"
                            :label="item.baseRegionName"
                            :value="item.baseRegionID"
                            >
                        </el-option>
                    </el-select>
                </el-form-item>     
                <el-form-item v-if="show">
                    <el-select size="small" v-model="searchForm.villageID" style="width:200px"  placeholder="请选择户籍村级行政区划"  >
                            <el-option
                            v-for="item in villageList"
                            :key="item.baseRegionID"
                            :label="item.baseRegionName"
                            :value="item.baseRegionID"
                            >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="villshow">
                    <el-select size="small" v-model="searchForm.villageID" style="width:200px"  placeholder="请选择户籍村级行政区划"  >
                            <el-option
                            v-for="item in villageList"
                            :key="item.baseRegionID"
                            :label="item.baseRegionName"
                            :value="item.baseRegionID"
                            >
                        </el-option>
                    </el-select>
                </el-form-item> 
                <el-form-item>
                    <el-button size="small" plain type="primary" icon="el-icon-search"  @click="onSearch">查询</el-button>
                </el-form-item>
                <!-- v-if="permission.isHaverewardannualreviewbatchaudit" -->
                <el-form-item v-if="isshow==false">
                    <el-button size="small" plain type="primary" icon="el-icon-s-check"  @click="onclickApplaylist()" v-if="disabled==true && permission.isHavecensuschangesapply">区划调整</el-button>
                    <el-button size="small" plain type="info" icon="el-icon-s-check"  @click="onclickApplaylist()" v-if="disabled==false&& permission.isHavecensuschangesapply" disabled>区划调整</el-button>
                    
                </el-form-item>
                <el-form-item v-if="isshow==true">
                   
                    <el-button size="small" plain type="info" icon="el-icon-s-check"  @click="onclickApplaylist()" v-if="permission.isHavecensuschangesapply" disabled>区划调整</el-button>
                    
                </el-form-item>
              
            </el-form>
        </div>
        <div class="searchtable" >
            <el-table
                ref="table"
                :data="applyaudituserlist"
                 border
                stripe
                v-loading="showDataLoading"
                :header-row-style="{height:'30px'}"
                :header-cell-style="{padding:'5px'}"
                :row-style="{height:'30px'}"
                :cell-style="{padding:'5px'}"
                :height="tableHeight"
                @selection-change="handleSelectionPolicyChange"
                >
                <el-table-column
                    type="selection"
                    width="55"
                    :selectable='checkboxSelect'>
                </el-table-column>
                <el-table-column prop="" label="编号" width="60">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
                </el-table-column>
                <el-table-column
                    prop="policyMeasureName"
                    label="政策"
                    min-width="160"
                    >
                </el-table-column>
                <el-table-column
                    prop="realName"
                    label="姓名"
                    width="100"
                    >
                </el-table-column>
             
                 <el-table-column
                    label="性别"
                    width="60" 
                   >
                    <template slot-scope="scope">
                        <span v-if="scope.row.sexID == 1">男</span>
                        <span v-if="scope.row.sexID == 2">女</span> 
                    </template>   
                </el-table-column>
                 <el-table-column
                    prop="certificateNo"
                    label="身份证号"
                    width="165"
                   >
                </el-table-column>
                 <el-table-column
                    label="户口性质"
                    width="85"
                   >
                  <template slot-scope="scope">
                        <span v-if="scope.row.accountNature == 1">农业</span>
                        <span v-if="scope.row.accountNature == 2">非农业</span> 
                  </template>
                   
                </el-table-column>
                 <el-table-column
                    prop="maritalStatus"
                    label="婚姻状况"
                    width="85"
                   >
                   <!-- 1初婚；2再婚；3离婚；4丧偶 -->
                    <template slot-scope="scope">
                        <span v-if="scope.row.maritalStatus == 1">初婚</span>
                        <span v-if="scope.row.maritalStatus == 2">再婚</span> 
                        <span v-if="scope.row.maritalStatus == 3">离婚</span>
                        <span v-if="scope.row.maritalStatus == 4">丧偶</span>
                    </template>  
                </el-table-column>
                  <el-table-column
                    prop="lsRegionParentInfo"
                    label="户籍地"
                    min-width="180"
                   >
                </el-table-column>
                  <el-table-column
                    prop="contactTel"
                    label="联系电话"
                     width="120"
                   >
                </el-table-column>
                
                <el-table-column
                    label="操作"
                   width="160" >
                    <template slot-scope="scope">
                        <el-button  type="text" size="mini" @click="editFunds(scope.row)"  >查看资料</el-button>
                        <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini"  v-if=" permission.isHavecensuschangesapply"   class="tablecolumn" @click="onclickApplay(scope.row)" :disabled="isshow">迁出</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pageblock">
            <el-pagination
                @size-change="handledatailSizeChange"
                @current-change="handledatailCurrentChange"
                :current-page="page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="datailtotalCount"
            >
            </el-pagination>
             </div>
        </div>
        <!-- 查看资料 -->  
        <el-dialog title="查看资料" :show-close="true"
          :close-on-click-modal="false"
          custom-class="dialog_wrap"
          :visible.sync="dialogdataFormVisible"
          class="eldialog"
          :modal-append-to-body="true"
          append-to-body
          :style="'margin-top:0px;left:' + initLeft()"
          
          >
            <!-- <Particulars :valueID="applyRecordID"  :indexID="keyindex" :markID="mark"></Particulars> -->
             <Particulars :valueID="applyRecordID"  :indexID="keyindex" :markID="mark" :markshow="markshowID"  :markauditStatus="markauditStatusID" :markuser="markuserID" :markpolicyMeasure="markpolicyMeasureID" :markrewardRecord="markrewardRecordID"></Particulars>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogdataFormVisible = false">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 迁出 -->
        <el-dialog title="迁出" :visible.sync="dialogFormVisible" :show-close="true"  custom-class="dialog_wrap"    @close="clearEditList('checkedForm')"   style="margin-top:0px;left: 0px;z-index: 2154;"  class="logindialog" width="900px">
            <el-form ref="checkedForm"  label-width="130px" :model="checkedForm" :rules="editRules">
                <el-form-item label="变更前行政区划:" >
                      <el-input size="small" v-model.trim="checkedForm.p1" placeholder="请输入变更前行政区划" :disabled="true" style="width:400px"></el-input>
                </el-form-item>
                <el-form-item label="变更后行政区划:" class="is-required  regionlist">
                    <div class="regionlist-item">
                            <el-form-item  class="is-required  regionlist"  prop="province01" >
                                <el-select size="small" v-model="checkedForm.province01" placeholder="请选择省"  @change="cityFormchange(2,checkedForm.province01)"  disabled>
                                    <el-option
                                    v-for="item in provincelist01"
                                    :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="regionlist-item">
                            <el-form-item  class="is-required  regionlist"  prop="city01" >
                                <el-select size="small" v-model="checkedForm.city01" placeholder="请选择市" @change="cityFormchange(3,checkedForm.city01)" >
                                    <el-option
                                    v-for="item in citylist01"
                                    :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="regionlist-item">
                                <el-form-item  class="is-required  regionlist"  prop="county01" >
                                <el-select size="small" v-model="checkedForm.county01" placeholder="请选择区/县"  @change="cityFormchange(4,checkedForm.county01)" >
                                    <el-option
                                    v-for="item in countylist01"
                                    :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="regionlist-item">
                            <el-form-item  class="is-required  regionlist"  prop="town01" >
                                <el-select size="small" v-model="checkedForm.town01" placeholder="请选择街道/乡/镇"  @change="cityFormchange(5,checkedForm.town01)" >
                                    <el-option
                                    v-for="item in townlist01"
                                    :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="regionlist-item">
                            <el-form-item  class="is-required  regionlist"  prop="village01" >
                                <el-select size="small" v-model="checkedForm.village01" placeholder="请选择社区/村"  >
                                    <el-option
                                    v-for="item in villagelist01"
                                    :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="medium" type="primary"  @click="oncheckSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {rewardannualreviewuserlistModel } from "@/request/windowtoaccept.js";
import { regionModule } from "@/request/systemmange.js";
import router from "@/router.js";
import { sysframe } from '@/tools/sysframe.js'
import $ from 'jquery'
import store from '@/store'
import Particulars from "@/components/windowtoaccept/particulars.vue";
import {publicFun} from '@/tools/time.js'
import {baseconfig} from '@/config.js'
import { permissionTool } from "@/tools/permissiontool.js";
import { moveoutrewardrecordinfolistModel } from "@/request/filemanage.js";
export default {
   components: {
        Particulars,
    },
    //  props: ["valueID","indexID","markID"],
    props: ["valueID","indexID","markID","markrewardRecord","markpolicyMeasure","markuser","markshow","markauditStatus"],
    data() {
        return {
             markshowID:0,
            markauditStatusID:0,
            markpolicyMeasureID:0,
            markuserID:0,
            markrewardRecordID:0,
            mark:2,
            keyindex:0,
            disabled:false,
            //迁出
            rewardRecordIDlist:[],
            policyMeasureIDlist:[],
            userIDlist:[],
            enjoyCensus:0,
            enjoyCensusAddress:'',

            applyRecordID:0,
            tableHeight:400,
            villageList:[],
            countryList:[],
            villageList1:[],
            countryList1:[],
            show:false,
            villshow:false,
            p_region_id:'',
            region_level:'',
            systemlist: [],

            lsp: [],
            permission: {
                isHavecensuschangesapply: false,
            },
            //进来加载数据是否展示loading圈
            showDataLoading: true,
            
            //搜索
            page: 1,
            pagesize: 10,
            datailtotalCount: 0,
            applyaudituserlist:[],
            // 搜索
            searchForm:{
                keywords:'',
                //户口性质
                registered:'',
                registeredlist:[
                    {
                        value:0,
                        label:'全部'
                    },
                    {
                        value:1,
                        label:'农业'
                    },
                    {
                        value:2,
                        label:'非农业',
                    },
                ],
                countryID:'',
                villageID:''
            },
            dialogdetailVisible:false,
            dialogdataFormVisible:false,
            dialogFormVisible:false,
            // 审核
            checkedForm:{
                selectType:1,
                p1:'',
                province01:'',
                city01:'',
                county01:'',
                town01:'',
                village01:'',
            },
            // 批量审核
            multiplePolicySelection:[],
            thisYears:0,
            provincelist01:[],
            citylist01:[],
            countylist01:[],
            townlist01:[],
            villagelist01:[],
            editRules:{
                province01: [
                    { required: true, message: '请选择省', trigger: 'change'  },
                ],
                city01: [
                    { required: true, message: '请选择市', trigger: 'change'  },
                ],
                county01: [
                    { required: true, message: '请选择区/县', trigger: 'change'  },
                ],
                town01: [
                    { required: true, message: '请选择街道/乡/镇', trigger: 'change'  },
                ],
                village01: [
                    { required: true, message: '请选择街道/乡/镇', trigger: 'change'  },
                ],
            },
            isshow:true,
            certificateNo:''
     };
  },
  created: async function () {
    await this. getapplyaudit1userlist(1,this.pagesize,'',0,0,0,0,this.certificateNo)
    this.tableHeight=($(".tab-content").height()-30-$(".searchcontent").outerHeight(true)-$(".pageblock").outerHeight(true))+'px'
    this.p_region_id =  store.getters.adminRegionID
    this.region_level = parseInt(store.getters.adminRegionLevel) +1
    console.log(this.region_level)
    console.log(this.region_level == 4)
    if( this.region_level == 4){
        this.show = true
        this.isshow=true
        this.getRegionList(this.region_level,this.p_region_id)      
    }
    if(this.region_level == 5){
        this.villshow=true
        this.isshow=false
        this.getRegionList(this.region_level,this.p_region_id)
    }
    console.log( this.show,this.villshow)
    this.permission.isHavecensuschangesapply = permissionTool.isHavePermission(
      "censuschangesapply",
      this.lsp
    );
    await this.getRegionList1(1,0)
    await this.getRegionList1(2,410000000000)
  },
  mounted: function () {},
  methods: {
    initLeft(){
        return sysframe.getSideBarLeft()
    },
       //获取城市列表
    async getRegionList(region_level,p_region_id) {
        await regionModule
            .regioninfogetlist(region_level,p_region_id)
            .then((response) => {
            switch (response.data.code) {
               case 100:{
                       let obj={
                            baseRegionID:-1,
                            baseRegionName:'全部'
                        }
                      if(region_level==1){
                        this.provinceList=response.data.result
                      }else if(region_level==2){
                         this.cityList=response.data.result
                      }else if(region_level==3){
                         this.districtList=response.data.result
                      }else if(region_level==4){
                         this.countryList=response.data.result
                         this.countryList.unshift(obj)
                      }else if(region_level==5){
                         this.villageList=response.data.result
                         this.villageList.unshift(obj)
                      }
                    //this.toDeal(response.data.result);
                    }
                    break;
                
            }
            })
            .catch((error) => {
            console.log("error", error);
            this.loading = false;
        });
    },
    searchFormchange(num2,parentID) {    
        this.villageList=[]; 
        this.searchForm.villageID = ""
        this.region_level=5
        this.getRegionList(5,parentID)
    },
    //列表
    async getapplyaudit1userlist(page,pagesize,key_words,account_nature,enjoy_census_region_level,countryID,villageID,id_number) {
        if(account_nature==''){
            account_nature=0
        }
        console.log(countryID,villageID,enjoy_census_region_level)
        let enjoy_census_region_id=0
        if(enjoy_census_region_level== 4){
          if(countryID==-1){
             enjoy_census_region_id =0
             enjoy_census_region_level=0
          }else if(countryID ==''&& villageID == ''){
            enjoy_census_region_id = 0
            enjoy_census_region_level=0
          }else if((countryID!==-1 && countryID!=='') &&(villageID!==-1 && villageID!=='') ){
            enjoy_census_region_id = villageID
            enjoy_census_region_level=5
          }else if((countryID!==-1 && countryID!=='') && (villageID==-1 || villageID=='') ){
            enjoy_census_region_id = countryID
            enjoy_census_region_level=4
          }
        }
        if(enjoy_census_region_level== 5){
          if(villageID==-1 || villageID==''){
            enjoy_census_region_id = 0
            enjoy_census_region_level=0
          }else{
            enjoy_census_region_id=villageID
            enjoy_census_region_level=5
          }
        } 
        if(enjoy_census_region_level==-1){
            enjoy_census_region_level=0
        }
        if(enjoy_census_region_level !=4 && enjoy_census_region_level !=5  ){
            enjoy_census_region_level=0
            enjoy_census_region_id=0
        }
          console.log('8888',this.certificateNo)
      this.applyaudituserlist = [];
      this.showDataLoading = true;
      await moveoutrewardrecordinfolistModel.moveoutrewardrecordinfolist(page,pagesize,key_words,account_nature,enjoy_census_region_level,enjoy_census_region_id,id_number).then((response) => {
          this.showDataLoading = false;
          if(response.data.lsp !==null){
              this.lsp=response.data.lsp
          }
          switch (response.data.code) {
            case 100:
              this.applyaudituserlist = response.data.result;
              this.applyaudituserlist.forEach(e=>{
                     e.lsRegionParentInfo1.forEach(m=>{
                        e.lsRegionParentInfo= m.provinceName+m.cityName+m.districtName+m.townshipName+m.villageName
                    })
              })
               this.datailtotalCount =  response.data.recordcount;
             
              break;
            case 101:
             this.applyaudituserlist=[]
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch((error) => {});
    },

   //更改每页显示条数
    async handledatailSizeChange(val) {
      this.pagesize = val;
      this.page = 1;
      this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.registered,parseInt(store.getters.adminRegionLevel) +1,this.searchForm.countryID,this.searchForm.villageID,this.certificateNo)
    },
    //设置当前页
    async handledatailCurrentChange(val) {
      this.page = val;
      this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.registered,parseInt(store.getters.adminRegionLevel) +1,this.searchForm.countryID,this.searchForm.villageID,this.certificateNo) 
    },
    // 查询
    async onSearch() {
        console.log(222,this.searchForm.villageID)
        if(this.searchForm.villageID!='' && this.searchForm.villageID!=-1){
            this.disabled=true
        }else{
            this.disabled=false
        }
        console.log(111,this.disabled)
        this.datailtotalCount = 0;
        this.page = 1;
        this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.registered,parseInt(store.getters.adminRegionLevel) +1,this.searchForm.countryID,this.searchForm.villageID,this.certificateNo)
      
    //   await this.getapplyaudit1userlist(this.page,this.pagesize,this.detailsearchForm.keywords,this.checkedForm.policy_measure_id)
    },


  
   
    // 查看资料
    editFunds(row){
      this.keyindex++
      this.dialogdataFormVisible=true
      this.applyRecordID=row.rewardRecordID
    },

    // 迁出
    //获取城市列表
    async getRegionList1(region_level,p_region_id) {
            await regionModule
                .regioninfogetlist(region_level,p_region_id)
                .then((response) => {
                switch (response.data.code) {
                    case 100:
                        if(region_level==1){
                            this.provincelist01=response.data.result
                            this.checkedForm.province01=410000000000
                        }else if(region_level==2){
                            this.citylist01=response.data.result
                        }else if(region_level==3){
                            this.countylist01=response.data.result
                        }else if(region_level==4){
                            this.townlist01=response.data.result
                        }else if(region_level==5){
                            this.villagelist01=response.data.result
                        }
                    break;
                    case 101:
                    break;
                    case 100002:
                       this.$message.error(baseconfig.no_permission_message);
                    break;
                    default:
                       this.$message.error(response.data.message);
                    break;  
                }
                })
                .catch((error) => {
                console.log("error", error);
                this.loading = false;
            });
    },
    cityFormchange(num2,parentID) {
        switch (num2) {
            case 2:
                this.citylist01=[]; 
                this.checkedForm.city01 = ""
                this.countylist01 = [];
                this.checkedForm.county01 = ""
                this.townlist01=[]; 
                this.checkedForm.town01 = ""
                this.villagelist01=[]; 
                this.checkedForm.village01 = ""
            
                this.getRegionList1(2,parentID)
                break;
            case 3:
                this.countylist01 = [];
                this.checkedForm.county01 = ""
                this.townlist01=[]; 
                this.checkedForm.town01 = ""
                this.villagelist01=[]; 
                this.checkedForm.village01 = ""
                this.getRegionList1(3,parentID)
                break;
            case 4:
                this.townlist01=[]; 
                this.checkedForm.town01 = ""
                this.villagelist01=[]; 
                this.checkedForm.village01 = ""
                this.getRegionList1(4,parentID)
                break;
            case 5:
                this.villagelist01=[]; 
                this.checkedForm.village01 = ""
                this.getRegionList1(5,parentID)
                break;
            default:
                break;
    }
    },
     // 批量迁出
    handleSelectionPolicyChange(val){
        this.multiplePolicySelection = val;
        this.checkedForm.selectType=1
        console.log(val)
    },
    onclickApplaylist(){
        this.checkedForm.selectType=2
        this.dialogFormVisible = true
        console.log(this.multiplePolicySelection)
        this.checkedForm.p1=this.multiplePolicySelection[0].lsRegionParentInfo
        this.enjoyCensus=this.multiplePolicySelection[0].enjoyCensus
    },
    onclickApplay(row){
        this.checkedForm.selectType=1
        // this.checkedForm.policy_measure_ids = `[` + row.rewardRecordID + `]`
        this.rewardRecordIDlist= `[` + row.rewardRecordID + `]`
        this.policyMeasureIDlist= `[` + row.policyMeasureID + `]`
        this.userIDlist= `[` + row.rewardUserID + `]`
        this.enjoyCensus=row.enjoyCensus
        this.checkedForm.p1=row.lsRegionParentInfo
        this.dialogFormVisible = true
    },
    // 确认提交
    oncheckSubmit(){
        this.$refs.checkedForm.validate(async valid=>{
            if(valid){
                if(this.checkedForm.selectType == 2){
                    let rewardRecordIDlist = []
                    let policyMeasureIDlist = []
                    let userIDlist = []
                    console.log('this.multiplePolicySelection',this.multiplePolicySelection)
                    this.multiplePolicySelection.forEach(e=>{  
                        rewardRecordIDlist.push(e.rewardRecordID)
                        policyMeasureIDlist.push(e.policyMeasureID)
                        userIDlist.push(e.rewardUserID)
                    })
                    
                    console.log(`[` + rewardRecordIDlist.toString()+ `]`,`[` + policyMeasureIDlist.toString()+ `]`,`[` + userIDlist.toString()+ `]`,this.enjoyCensus,this.checkedForm.village01,2)
                    this.applybatchapprove(`[` + rewardRecordIDlist.toString()+ `]`,`[` + policyMeasureIDlist.toString()+ `]`,`[` + userIDlist.toString()+ `]`,this.enjoyCensus,this.checkedForm.village01,2)
                }else{
                    this.applybatchapprove(this.rewardRecordIDlist,this.policyMeasureIDlist,this.userIDlist,this.enjoyCensus,this.checkedForm.village01,1)
                }
            }else{
                return false
            }
        }) 
    },
    async applybatchapprove(reward_record_ids,policy_measure_ids,reward_user_ids,old_census_region_id,new_census_region_id,move_out_type)  {
      await moveoutrewardrecordinfolistModel.censuschangesapply(reward_record_ids,policy_measure_ids,reward_user_ids,old_census_region_id,new_census_region_id,move_out_type) 
        .then((response) => {
          switch (response.data.code) {
            case 100:{
                  this.dialogFormVisible = false
                  const h = this.$createElement;
                  this.$notify({
                      title: "成功",
                      message: h("span", response.data.message),
                      type: "success",
                  });
                   this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.registered,parseInt(store.getters.adminRegionLevel) +1,this.searchForm.countryID,this.searchForm.villageID,this.certificateNo)
                }
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch(function (error) {});
    },

    // 清空
    clearEditList(checkedForm){
        this.$refs[checkedForm].resetFields();
    },
     checkboxSelect(row, rowIndex){
        if(this.isshow==false){
            return true // 禁用
        }else{
            return false // 不禁用
        }
    },
  },
};
</script>
<style scoped>
.logindialog >>>.el-dialog{
    width: 900px;
}
.logindialog >>>.el-form-item__content{
    display: flex;
    align-items: center;
}
.regionlist >>>.el-input{
    width: 140px ;
}
.regionlist-item{
    margin-right: 2px;
}
</style>

